module.exports = __webpack_public_path__ + "static/img/jjfa_wy.a2f2c70c.png";